import { render, staticRenderFns } from "./DevelopmentPage.vue?vue&type=template&id=1ae0bd58"
import script from "./DevelopmentPage.vue?vue&type=script&lang=ts"
export * from "./DevelopmentPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports